import { c as _c } from "react/compiler-runtime";
// The one tappable row: optional lead (initials), label, muted trailing count (or a word: a kind, a link's kind) or chevron. Pressed = selected
// filter. Used bare in the nav and inside group lists (GroupRow). Styles: book.css `.row`.
import type { ButtonHTMLAttributes, ReactNode } from "react";
type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  lead?: ReactNode;
  label: ReactNode;
  count?: number | string | null;
  chevron?: boolean;
  danger?: boolean;
  t?: string;
  id?: string;
};
export function Row(t0) {
  const $ = _c(28);
  let chevron;
  let className;
  let count;
  let danger;
  let id;
  let label;
  let lead;
  let rest;
  let t;
  if ($[0] !== t0) {
    ({
      lead,
      label,
      count,
      chevron,
      danger,
      t,
      id,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = chevron;
    $[2] = className;
    $[3] = count;
    $[4] = danger;
    $[5] = id;
    $[6] = label;
    $[7] = lead;
    $[8] = rest;
    $[9] = t;
  } else {
    chevron = $[1];
    className = $[2];
    count = $[3];
    danger = $[4];
    id = $[5];
    label = $[6];
    lead = $[7];
    rest = $[8];
    t = $[9];
  }
  const t1 = danger && "danger";
  let t2;
  if ($[10] !== className || $[11] !== t1) {
    t2 = ["row", t1, className].filter(Boolean);
    $[10] = className;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[13] !== label) {
    t4 = <span className="label">{label}</span>;
    $[13] = label;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== count) {
    t5 = count !== undefined && <span className="count">{count || ""}</span>;
    $[15] = count;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== chevron) {
    t6 = chevron && <span className="chev" aria-hidden={true}>{"›"}</span>;
    $[17] = chevron;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== id || $[20] !== lead || $[21] !== rest || $[22] !== t || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t7 = <button type="button" className={t3} data-t={t} data-id={id} {...rest}>{lead}{t4}{t5}{t6}</button>;
    $[19] = id;
    $[20] = lead;
    $[21] = rest;
    $[22] = t;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}